import { render, staticRenderFns } from "./UserInfoForm.vue?vue&type=template&id=cb7c1464"
import script from "./UserInfoForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./UserInfoForm.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports